compiler('[shop-setup-instructions]', (element) => {
  const shopSystem = element.getAttribute('shop-setup-instructions');

  fetch(`/shop_setup_instructions/${shopSystem}`)
    .then(response => response.text())
    .then(html => element.innerHTML = html)
    .catch(error => console.error(`Could not show setup instruction for ${shopSystem}`, error));
});
